"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCloseIconClass = exports.useAlertVariantClass = exports.actionColors = exports.iconColors = void 0;
var theme_1 = require("../../theme");
var variants = {
    neutral: {
        container: 'neutral',
        text: 'on-neutral',
    },
    info: {
        container: 'info-weak',
        text: 'on-info-weak',
    },
    success: {
        container: 'success-weak',
        text: 'on-success-weak',
    },
    attention: {
        container: 'attention-weak',
        text: 'on-attention-weak',
    },
    critical: {
        container: 'critical-weak',
        text: 'on-critical-weak',
    },
};
exports.iconColors = {
    neutral: 'base',
    info: 'info',
    success: 'success',
    attention: 'attention',
    critical: 'critical',
};
var closeIconClass = {
    neutral: 'squid-stroke-alias-color-text-on-neutral',
    info: 'squid-stroke-alias-color-text-on-info-weak',
    success: 'squid-stroke-alias-color-text-on-success-weak',
    attention: 'squid-stroke-alias-color-text-on-attention-weak',
    critical: 'squid-stroke-alias-color-text-on-critical-weak',
};
exports.actionColors = {
    neutral: 'neutral',
    info: 'on-info',
    success: 'on-success',
    attention: 'on-warning',
    critical: 'on-critical',
};
var useAlertVariantClass = function (variant, branding) {
    var bgColors = (0, theme_1.useBackgroundColors)(branding);
    var variantClass = variants[variant];
    return {
        container: bgColors[variantClass.container],
        text: variantClass.text,
    };
};
exports.useAlertVariantClass = useAlertVariantClass;
var generateCloseIconClass = function (variant) {
    return closeIconClass[variant];
};
exports.generateCloseIconClass = generateCloseIconClass;
